import React, { Fragment } from "react";

function getFriendlyErrorSummary(errorMessage) {
  const raw = String(errorMessage || "")
    .replace(/^Error:\s*/i, "")
    .trim()
    .split("\n")[0]
    .trim();
  const lower = raw.toLowerCase();

  if (!raw) {
    return "An unexpected problem stopped this page.";
  }

  if (
    lower.includes("network") ||
    lower.includes("failed to fetch") ||
    lower.includes("timeout") ||
    lower.includes("timed out") ||
    lower.includes("offline")
  ) {
    return "A connection problem interrupted this page.";
  }

  if (
    lower.includes("is not a function") ||
    lower.includes("undefined is not") ||
    lower.includes("null is not an object") ||
    lower.includes("cannot read propert") ||
    lower.includes("cannot read properties of") ||
    lower.includes("is not an object") ||
    lower.includes("invalid hook call") ||
    lower.includes("rendered more hooks") ||
    lower.includes("typeerror") ||
    lower.includes("referenceerror")
  ) {
    return "This page could not finish loading its content.";
  }

  if (
    lower.includes("unexpected token") ||
    lower.includes("json") ||
    lower.includes("is not valid json")
  ) {
    return "The app received unexpected data and could not continue.";
  }

  if (
    lower.includes("permission") ||
    lower.includes("unauthorized") ||
    lower.includes("forbidden")
  ) {
    return "Something needed for this action was missing or invalid.";
  }

  const looksTechnical =
    /(?:\bat\b|\/|\\|\.tsx?\b|\.jsx?\b|evaluating|invariant|minified)/i.test(
      raw,
    ) || raw.length > 140;

  if (!looksTechnical) {
    return raw;
  }

  return "An unexpected problem stopped this page.";
}

class MyErrorBoundary extends React.Component {
  state = {
    errorMessage: "",
  };

  static getDerivedStateFromError(error) {
    return { errorMessage: error?.message || error?.toString?.() || "" };
  }

  componentDidCatch(error, info) {
    // Keep full stack in the console for developers only.
    console.error("Web ErrorBoundary caught:", error, info?.componentStack);
  }

  render() {
    if (this.state.errorMessage) {
      const summary = getFriendlyErrorSummary(this.state.errorMessage);
      return (
        <Fragment>
          <div className="page-wrapper">
            <div className="error-wrapper">
              <div className="container">
                <img
                  className="img-100"
                  src="/assets/images/sad.png"
                  alt=""
                />
                <div className="error-heading">
                  <h2 className="headline font-primary">
                    Something went wrong
                  </h2>
                </div>
                <div className="col-md-8 offset-md-2">
                  <p className="sub-content">
                    The page hit an unexpected error. You can go home and try
                    again.
                  </p>
                  <p
                    className="sub-content"
                    style={{
                      marginTop: 12,
                      padding: "12px 14px",
                      background: "#f8fafc",
                      border: "1px solid #e8edf5",
                      borderRadius: 8,
                      color: "#0f172a",
                      fontWeight: 500,
                    }}
                  >
                    <span
                      style={{
                        display: "block",
                        fontSize: 11,
                        fontWeight: 600,
                        color: "#94a3b8",
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                        marginBottom: 6,
                      }}
                    >
                      What happened
                    </span>
                    {summary}
                  </p>
                </div>
                <div>
                  <a className="btn btn-primary-gradien btn-lg" href="/">
                    BACK TO HOME PAGE
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    }
    return this.props.children;
  }
}

export default MyErrorBoundary;
